import { setCookie } from './helper-function/coockie/setCookie';
import { getCookie } from './helper-function/coockie/getCookie';
import { deleteCookie } from './helper-function/coockie/deleteCookie';
import { isValidMail } from '../../../../Common/Resources/src_front/js/helper-functions/isValidMail';
import { initRippleAnimation } from '../../../../Common/Resources/templates/components/RippleAnimation/initRippleAnimation';
import { initFunnelHash } from '../../../../Common/Resources/src_front/js/components/initFunnelHash';
import { initDetectionOrganicTraffic } from '../../../../Common/Resources/src_front/js/components/initDetectionOrganicTraffic';

window.addEventListener('DOMContentLoaded', function () {
    initFunnelHash();
    // always after initFunnelHash
    initDetectionOrganicTraffic();
    initRippleAnimation();

    //modal-sale-offer
    let modalOffer = document.getElementById('modal-sale-offer');
    let closeBtnOffer = document.getElementsByClassName('close-modal-offer')[0];

    if (modalOffer && closeBtnOffer) {
        closeBtnOffer.onclick = function () {
            modalOffer.style.display = 'none';
        };
    }

    //sticky block
    if (document.querySelector('.timer-block-sticky')) {
        const nav = document.querySelector('.timer-block-sticky');
        const navTop = nav.offsetTop;

        window.addEventListener('scroll', stickyNavigation);

        function stickyNavigation() {
            const headerHeight = document.querySelector('.header').clientHeight;

            if (window.scrollY >= navTop - headerHeight) {
                // nav offsetHeight = height of nav
                document.querySelector('.screen-block-container').style.marginBottom = nav.offsetHeight + 'px';
                document.querySelector('.timer-block-sticky').classList.add('fixed-nav');
            } else {
                document.querySelector('.screen-block-container').style.marginBottom = 0;
                document.querySelector('.timer-block-sticky').classList.remove('fixed-nav');
            }
        }

        window.addEventListener('scroll', stickyNavigation);
    }

    //timer init
    if (document.querySelector('.timer-block')) {
        if (document.querySelector('.my-timer--value')) {
            let // spanCreate = document.createElement("SPAN"),
                myTimerMD = document.querySelector('.my-timer-m-d'),
                myTimerMO = document.querySelector('.my-timer-m-o'),
                myTimerSD = document.querySelector('.my-timer-s-d'),
                myTimerSO = document.querySelector('.my-timer-s-o'),
                myTimerHD = document.querySelector('.my-timer-h-d'),
                myTimerHO = document.querySelector('.my-timer-h-o'),
                footerTimerMD = document.querySelector('.footer-timer-m-d'),
                footerTimerMO = document.querySelector('.footer-timer-m-o'),
                footerTimerSD = document.querySelector('.footer-timer-s-d'),
                footerTimerSO = document.querySelector('.footer-timer-s-o'),
                footerTimerHD = document.querySelector('.footer-timer-h-d'),
                footerTimerHO = document.querySelector('.footer-timer-h-o');

            startTimerParent();

            function startTimerParent() {
                let totalTimer50off = Date.parse(new Date()) / 1000,
                    timer50off = totalTimer50off + 1200;

                if (
                    !getCookie('umobixTimerOff50') ||
                    getCookie('umobixTimerOff50') == null ||
                    getCookie('umobixTimerOff50') - totalTimer50off < 0
                ) {
                    setCookie('umobixTimerOff50', timer50off, timer50off);
                }

                let totalSeconds = getCookie('umobixTimerOff50') - totalTimer50off,
                    hMain = Math.trunc(totalSeconds / 3600) % 24,
                    mMain = Math.trunc(totalSeconds / 60) % 60,
                    sMain = Math.trunc(totalSeconds) % 60;

                outputSpanTimer(String(hMain), myTimerHO, myTimerHD);
                outputSpanTimer(String(mMain), myTimerMO, myTimerMD);
                outputSpanTimer(String(sMain), myTimerSO, myTimerSD);
                outputSpanTimer(String(hMain), footerTimerHO, footerTimerHD);
                outputSpanTimer(String(mMain), footerTimerMO, footerTimerMD);
                outputSpanTimer(String(sMain), footerTimerSO, footerTimerSD);

                function outputSpanTimer(textInto, currSpanT, currSpanO) {
                    currSpanT.innerHTML = '';
                    currSpanO.innerHTML = '';
                    if (!textInto[1]) {
                        if (!textInto) {
                            currSpanO.innerHTML = '0';
                            currSpanT.innerHTML = '0';
                        } else {
                            currSpanO.innerHTML = '0';
                            currSpanT.innerHTML = textInto[0];
                        }
                    } else {
                        currSpanT.innerHTML = textInto[1];
                        currSpanO.innerHTML = textInto[0];
                    }
                }

                if (!hMain && !mMain && !sMain) {
                    deleteCookie('umobixTimerOff50');
                    window.location.reload();
                    return;
                }

                setTimeout(startTimerParent, 1000);
            }
        }
    }
    if (document.querySelector('.timer-block-prices')) {
        if (document.querySelector('.my-timer--value')) {
            let // spanCreate = document.createElement("SPAN"),
                myTimerMD = document.querySelector('.my-timer-m-d'),
                myTimerMO = document.querySelector('.my-timer-m-o'),
                myTimerSD = document.querySelector('.my-timer-s-d'),
                myTimerSO = document.querySelector('.my-timer-s-o'),
                myTimerHD = document.querySelector('.my-timer-h-d'),
                myTimerHO = document.querySelector('.my-timer-h-o'),
                myTimerDO = document.querySelector('.my-timer-d-o'),
                myTimerDD = document.querySelector('.my-timer-d-d');

            startTimerParent();

            function startTimerParent() {
                let totalTimerSalesPrices = Date.parse(new Date()) / 1000,
                    timerSalesPrices = totalTimerSalesPrices + 691200;

                if (!getCookie('timerSalesPrices')) {
                    setCookie('timerSalesPrices', timerSalesPrices, 8);
                }
                let totalSeconds = getCookie('timerSalesPrices') - totalTimerSalesPrices,
                    dMain = Math.floor(totalSeconds / 60 / 60 / 24),
                    hMain = Math.trunc(totalSeconds / 3600) % 24,
                    mMain = Math.trunc(totalSeconds / 60) % 60,
                    sMain = Math.trunc(totalSeconds) % 60;

                outputSpanTimer(String(dMain), myTimerDO, myTimerDD);
                outputSpanTimer(String(hMain), myTimerHO, myTimerHD);
                outputSpanTimer(String(mMain), myTimerMO, myTimerMD);
                outputSpanTimer(String(sMain), myTimerSO, myTimerSD);

                function outputSpanTimer(textInto, currSpanT, currSpanO) {
                    currSpanT.innerHTML = '';
                    currSpanO.innerHTML = '';
                    if (!textInto[1]) {
                        if (!textInto) {
                            currSpanO.innerHTML = '0';
                            currSpanT.innerHTML = '0';
                        } else {
                            currSpanO.innerHTML = '0';
                            currSpanT.innerHTML = textInto[0];
                        }
                    } else {
                        currSpanT.innerHTML = textInto[1];
                        currSpanO.innerHTML = textInto[0];
                    }
                }

                if (!hMain && !mMain && !sMain) {
                    eraseCookie('timer50off');
                    window.location.reload();
                    return;
                }

                setTimeout(startTimerParent, 1000);
            }
        }
    }
    if (document.querySelector('.whatsapp-short')) {
        let footerLinks = document.querySelectorAll('.footer-item');
        footerLinks.forEach((item) => {
            item.onclick = () => {
                setCookie('pageBackShorts', 1, 999);
            };
        });
    }

    window.addEventListener('resize', setDefaultAccordions);

    function setDefaultAccordions() {
        if (window.innerWidth < 780) return false;
        const accordionsBody = document.querySelectorAll('.features-advantage-description');
        if (!accordionsBody.length) return false;
        for (let i = 0; i < accordionsBody.length; i++) {
            accordionsBody[i].style.height = '';
        }
    }

    initAccordions('.fa-trigger');
    function initAccordions(selector) {
        let elements = document.querySelectorAll(selector);
        let elementChildFunction = function () {
            if (window.innerWidth > 780) return false;
            let childElement = this.querySelector('.features-advantage-description');
            let childElementStyles = window.getComputedStyle(childElement);
            let childElementHeight = childElementStyles.getPropertyValue('height');
            if (childElementHeight === '0px') {
                childElement.style.height = childElement.scrollHeight + 'px';
            } else {
                childElement.style.height = childElement.scrollHeight + 'px';
                window.getComputedStyle(childElement, null).getPropertyValue('height');
                childElement.style.height = '0px';
            }
            childElement.addEventListener('transitionend', () => {
                if (childElement.style.height !== '0px') {
                    childElement.style.height = 'auto';
                }
            });
        };
        for (let i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', elementChildFunction, false);
        }
    }

    // MAIN PAGE NAV PHONE
    if (document.querySelector('.button-video-view')) {
        document.querySelector('.button-video-view').addEventListener('click', () => {
            document.querySelector('.first-screen--content--left').classList.toggle('active');
        });
    }

    // features-accordion init
    let accordionFeatures = {
        init: function (target) {
            let featuresLists = document.querySelectorAll('.feature-item');
            if (featuresLists.length > 0) {
                for (let featureList of featuresLists) {
                    featureList.addEventListener('click', accordionFeatures.select);
                }
            }
        },

        select: function () {
            this.classList.toggle('collapsed');
        },
    };
    accordionFeatures.init('.feature__wrapper');

    // faq-accordion init
    let accordion = {
        init: function (target) {
            let headers = document.querySelectorAll('.faq-item');
            if (headers.length > 0) {
                for (let head of headers) {
                    head.addEventListener('click', accordion.select);
                }
            }
        },

        select: function () {
            this.classList.toggle('collapsed');
        },
    };
    accordion.init('.faq-wrapper');

    // faq-accordion
    let accordionFeaturesReNew = {
        init: function (target) {
            let featuresLists = document.querySelectorAll('.features-collapse');
            if (featuresLists.length > 0) {
                for (let featureList of featuresLists) {
                    featureList.addEventListener('click', accordionFeatures.select);
                }
            }
        },

        select: function () {
            this.classList.toggle('collapsed');
        },
    };
    accordionFeaturesReNew.init('.prices-item');

    //sign up
    if (document.querySelector('#tryStepNew')) {
        function tryNowValidator(event) {
            let emailValue = document.getElementById('tryNowEmail').value;
            let validEmail = isValidMail(emailValue);
            if (validEmail) {
                document.getElementById('validationInput')?.classList.remove('error');
                document.getElementById('tryNowEmail')?.classList.remove('error');
            } else {
                document.getElementById('validationInput')?.classList.add('error');
                document.getElementById('tryNowEmail')?.classList.add('error');
            }
            if (validEmail && event === 'submit') {
                document.getElementById('tryNowForm')?.submit();
            }
        }

        document.querySelector('#tryNowForm')?.addEventListener('submit', function (e) {
            e.preventDefault();
            tryNowValidator('submit');
        });

        document.querySelector('#tryNowEmail')?.addEventListener('change', function (e) {
            e.preventDefault();
            tryNowValidator();
        });
    }
});
